/*
 * CORK - videos de clientes (seccion cork_ugc_home de la home) reproducidos dentro de la pagina.
 * 29-09-2026. Las tarjetas vienen del metafield de tienda custom.ugc_reels y enlazan a Instagram;
 * este script cambia cada enlace de Instagram por su MP4 subido a Shopify (Contenido > Archivos,
 * ugc-1..8.mp4) y lo reproduce dentro de la tarjeta al tocarla.
 * Si se anade un reel nuevo: subir el MP4 y anadir su linea en VIDEOS (id del reel -> URL del MP4).
 * Si un reel no esta en la lista, su tarjeta sigue enlazando a Instagram.
 * Se carga desde snippets/cork-shipping-notice.liquid (solo en la home).
 */
(function () {
  if (window.__corkUgcInline) return;
  window.__corkUgcInline = true;

  var CDN = 'https://cdn.shopify.com/videos/c/vp/';
  var VIDEOS = {
    'Dc0xDUItKZz': CDN + '71a9ecc1d90b4c4cbcb4dde03794bc5a/71a9ecc1d90b4c4cbcb4dde03794bc5a.HD-720p-1.6Mbps-95904128.mp4', // ugc-7
    'DdCCOKgtOMw': CDN + 'c5a8c9d88ea24ddeb0774aa6e56f2738/c5a8c9d88ea24ddeb0774aa6e56f2738.HD-720p-1.6Mbps-95904129.mp4', // ugc-8
    'DcEAqLDMLMD': CDN + 'c1bc8b3f8e4b4f6da21643ace1992666/c1bc8b3f8e4b4f6da21643ace1992666.HD-720p-1.6Mbps-95904114.mp4', // ugc-1
    'DbirOerto4p': CDN + 'e21ccdb9144e4d63a818d8d4228b716d/e21ccdb9144e4d63a818d8d4228b716d.HD-720p-1.6Mbps-95904115.mp4', // ugc-2
    'DanQ9t6FbAb': CDN + 'c8f6f0c59a974873b17abc0d09715c98/c8f6f0c59a974873b17abc0d09715c98.HD-720p-1.6Mbps-95904116.mp4', // ugc-3
    'DYFAvQXNtn8': CDN + '2b131a4463214dc094c7a01a4b592b09/2b131a4463214dc094c7a01a4b592b09.HD-720p-1.6Mbps-95904119.mp4', // ugc-4
    'DZ71ScaKzIN': CDN + 'ff4cc0011a7d4eb09f3b1099e3cf32c6/ff4cc0011a7d4eb09f3b1099e3cf32c6.HD-720p-1.6Mbps-95904121.mp4', // ugc-5
    'DbFeEyutS4D': CDN + '242ba0a3748b48a78030d15daff08a3f/242ba0a3748b48a78030d15daff08a3f.HD-720p-1.6Mbps-95904125.mp4'  // ugc-6
  };

  var SUB = {
    es: 'Toca un v\u00eddeo para verlo.',
    ca: 'Toca un v\u00eddeo per veure\u2019l.',
    en: 'Tap a video to watch it.',
    fr: 'Touchez une vid\u00e9o pour la regarder.',
    de: 'Tippe auf ein Video, um es anzusehen.',
    it: 'Tocca un video per guardarlo.',
    pt: 'Toca num v\u00eddeo para o ver.'
  };

  function reelId(href) {
    var m = (href || '').match(/instagram\.com\/(?:p|reel)\/([^\/?#]+)/i);
    return m ? m[1] : null;
  }

  function pauseOthers(current) {
    document.querySelectorAll('.cpu-tile video').forEach(function (v) {
      if (v !== current) v.pause();
    });
  }

  function play(a, src) {
    var img = a.querySelector('img');
    var box = document.createElement('div');
    box.className = a.className;
    var v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    if (img) v.poster = img.currentSrc || img.src;
    v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;background:#000';
    v.addEventListener('play', function () { pauseOthers(v); });
    box.appendChild(v);
    a.replaceWith(box);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var any = false;
    document.querySelectorAll('a.cpu-tile').forEach(function (a) {
      var src = VIDEOS[reelId(a.getAttribute('href'))];
      if (!src) return;
      any = true;
      a.removeAttribute('target');
      a.setAttribute('href', src);
      var h = a.querySelector('.cpu-handle');
      if (h) h.remove();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        play(a, src);
      });
    });
    if (!any) return;
    var lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
    var sub = document.querySelector('.cpu-sub');
    if (sub && SUB[lang]) sub.textContent = SUB[lang];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
